export default __webpack_public_path__ + "static/media/midasi_point_th_pc@2x.22cef6b2.png";